<template>
    <div>Проекты</div>
    <div class="ai-tab-bar-container d-flex">
        <div v-for="project in projectsList" :key="project.id">
            <ai-tab-bar-item
                :class="selectedTabItem(project.id)"
                :id="project.id"
                :key="project.description"
                :view="{buttonCloseHide: true, title:  project.description}"
                :name="`tabBarItem${project.id}`"
                @item-click="selectedProject(project.id)"
            />
        </div>
    </div>
    <dx-data-grid
        style="flex-grow: 1"
        :data-source="typesList"
        :remote-operations="false"
        :allow-column-reordering="true"
        :row-alternation-enabled="true"
        :show-column-lines="true"
        :show-borders="true"
        :height="50"
        :width="'100%'"
        :column-min-width="120"
        :word-wrap-enabled="true"
    >
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />

        <dx-column
            caption="Вид объета"
            data-field="name"
            data-type="string"
        />

        <dx-master-detail
            :enabled="true"
            template="masterDetailTemplate"
        />

        <template #masterDetailTemplate="{ data: cell }">
            <arki-project-object-component
                :data-source="dataSourceObjects[cell.data.id]"
                :columns="columnsObjects[cell.data.id]"
            />
        </template>

    </dx-data-grid>
</template>

<script>
import aiTabBarItem from '@/layouts/main-layout/components/tab-bar/tab-bar-item.vue';
import arkiProjectObjectComponent from '@/views/arki/views/request/project/arki-project-object-component.vue';
export default {
    name: 'arki-project-component',
    components: {
        aiTabBarItem,
        arkiProjectObjectComponent
    }
};
</script>

<script setup>
import { onBeforeMount, ref, defineProps } from 'vue';
import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxLoadPanel,
    DxSorting,
    DxMasterDetail
} from 'devextreme-vue/data-grid'

import { getProjects } from '@/views/arki/services/arki-request-service';
import { getCharacters, getObjectTypes } from '@/views/arki/services/arki-character-service';

const { requestId } = defineProps({
    requestId: Number
})

const projectsList = ref([]),
     sate = ref({ selectedProjectId: null}),
     typesList = ref([]),
     dataSourceObjects = ref({}),
     columnsObjects = ref({})
    ;

const selectedTabItem = (projectId) => {
    return sate.value.selectedProjectId === projectId && 'ai-tab-bar-item-selected' || '';
};

onBeforeMount(async () => {
    typesList.value = await getObjectTypes();
    await fillCharacterColumns();
    await reloadData();
});

const reloadData = async () => {
    projectsList.value = await getProjects(requestId);
    selectedProject(projectsList.value[0].id);
}

const selectedProject = (projectId) => {
    sate.value.selectedProjectId = projectId;
    const project = projectsList.value.find(project => project.id === sate.value.selectedProjectId);

    typesList.value.forEach(async type => {
        dataSourceObjects.value[type.id] = project.objects.filter(object => object.typeId === type.id);
    });
}

const fillCharacterColumns = async () => {
    const characters = await getCharacters();

    characters.forEach(char => {
        columnsObjects.value[char['kod_vid_object']] = char.characters;
    });
}

</script>

<style lang="scss" scoped>

:deep(.dx-master-detail-cell) {
    padding: 1px !important;
}

</style>
